import { createContext, useContext } from 'react'

import { SavedFilterStructure } from '@/Atomic/Organisms/FilterBuilder'

export interface SegmentFilterContextType {
  isFilterModalOpen: boolean
  filter: SavedFilterStructure | undefined
  listId?: string
  openFilterModal: () => void
  closeFilterModal: () => void
  saveFilter: (newFilter: SavedFilterStructure) => void
}

export const SegmentFilterContext = createContext<
  SegmentFilterContextType | undefined
>(undefined)

export const useSegmentFilterContext = () => {
  const context = useContext(SegmentFilterContext)
  if (!context) {
    throw new Error(
      'useSegmentFilterContext must be used within a SegmentFilter.Provider',
    )
  }
  return context
}
